import classNames from 'classnames';

export const InsightsNavItem = ({
  children,
  dataCy,
  isSelected,
  onClick,
}: {
  children: React.ReactNode;
  dataCy?: string;
  isSelected?: boolean;
  onClick: () => void;
}) => {
  return (
    <button
      className={classNames(
        'vai-block vai-font-inter vai-cursor-pointer vai-border-0 vai-bg-transparent vai-p-0 vai-m-0 vai-outline-none focus:vai-ring-0 select-none focus:vai-outline-none active:vai-bg-transparent',
        'hover:vai-opacity-80 hover:vai-border-b-2 hover:vai-border-primary',
        !isSelected &&
          'vai-text-muted-foreground vai-border-b-2 vai-border-transparent',
        isSelected &&
          'vai-text-black vai-border-b-2 vai-border-solid vai-border-primary',
      )}
      data-cy={dataCy}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
